import { render, staticRenderFns } from "./ListCoureurs.vue?vue&type=template&id=53bdcebe&scoped=true&"
import script from "./ListCoureurs.vue?vue&type=script&lang=js&"
export * from "./ListCoureurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdcebe",
  null
  
)

export default component.exports